@if ($pageState(); as vm) { @if (vm?.status !== 'idle') { @if (vm?.pageResponse?.pageAsset?.layout?.header) { @if
(vm?.pageResponse?.content?.navigation?.children) {
<!-- <custom-dot-cms-uve-header-navigation [items]="vm.pageResponse?.content?.navigation?.children || []" /> -->
<custom-dot-cms-uve-header-navigation [navLinks]="vm?.pageResponse?.content?.navigation" />
} } } }

<!-- {{ $pageState() | json }} -->
